@if( menus()) {
<div id="header">
    <div
        [ngClass]="showScroll ? 'header-up' : 'header-down'"
        class="bg-bgHeader py-[8px] w-full z-[9999] fixed top-0 max-md:py-3"
    >
        <div
            class="flex items-center justify-center gap-x-5 px-[15px] max-2xl:gap-x-3 max-lg:justify-between"
        >
            <div class="header-logo mr-[60px] max-2xl:mr-[0px]">
                <a
                    [routerLink]="
                        localeDefaultService()?.code === 'en' ? '/en' : ''
                    "
                    [rel]="
                        localeDefaultService()?.code === 'en'
                            ? 'nofollow'
                            : 'dofollow'
                    "
                >
                    <img
                        src="assets/image/global/logo.webp"
                        alt="logo Volio Group"
                        title="logo Volio Group"
                        width="100%"
                        height="100%"
                        class="max-md:w-[70px]"
                        fetchpriority="high"
                    />
                </a>
            </div>
            <div class="max-lg:hidden">
                <nav id="nav">
                    <ul
                        id="navigation"
                        class="flex items-center justify-center"
                    >
                        @for (item of menus()?.values; track $index) {
                        @if(item.description.indexOf( '/tuyen-dung' ) >= 0 ||
                        item.description.indexOf( '/recruit' ) >= 0 ||
                        item.description.indexOf( '/su-kien' ) >= 0 ||
                        item.description.indexOf( '/event' ) >= 0){
                        <li
                            class="leading-[32px] text-white text-base font-semibold uppercase max-2xl:text-sm"
                        >
                            <a
                                class="mx-4 px-4 py-4 block max-2xl:mx-2 max-2xl:px-2 max-xl:mx-1"
                                [routerLink]="item.description"
                                [routerLinkActiveOptions]="{
                                    exact: false
                                }"
                                [routerLinkActive]="['is-active']"
                                >{{ item.title }}
                            </a>
                        </li>
                        } @else if (item.description.indexOf('/ecosystem') >= 0)
                        {
                        <li
                            class="leading-[32px] relative cursor-pointer text-white text-base font-semibold uppercase max-xl:text-sm"
                        >
                            <div
                                class="item-ecosystem relative mx-4 px-4 py-4 block max-2xl:mx-2 max-2xl:px-2 max-xl:mx-1"
                                (click)="op.toggle($event)"
                                [class.is-active]="
                                    isLinkActive(item.description)
                                "
                            >
                                {{ item.title }}
                            </div>
                        </li>
                        } @else {
                        <li
                            class="leading-[32px] text-white text-base font-semibold uppercase max-xl:text-sm"
                        >
                            <a
                                class="mx-4 px-4 py-4 block max-2xl:mx-2 max-2xl:px-2 max-xl:mx-1"
                                [routerLink]="item.description"
                                [routerLinkActiveOptions]="{
                                    exact: true
                                }"
                                [routerLinkActive]="['is-active']"
                                >{{ item.title }}
                            </a>
                        </li>
                        } }
                    </ul>
                </nav>
            </div>
            <div class="flex items-center gap-x-6">
                <div
                    class="card flex justify-content-center language pl-[60px] max-2xl:pl-[16px] max-2xl:"
                >
                    <p-select
                        [options]="countries"
                        [ngModel]="selectedCountry()"
                        optionLabel="name"
                        placeholder=""
                        (onChange)="onCountryChange($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div
                                class="flex items-center gap-[10px] item-country max-md:gap-[6px]"
                            >
                                <img
                                    [src]="selectedCountry().icon"
                                    alt=""
                                    width="32px"
                                    height="32px"
                                    class="max-2xl:w-7 max-2xl:h-7 max-md:w-5 max-md:h-5"
                                />
                                <div
                                    class="text-sizeTitleMedium text-white font-bold max-2xl:text-base max-md:text-[11px] max-md:leading-5"
                                >
                                    {{ selectedCountry().name }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="flex items-center gap-2">
                                <img
                                    [src]="country.icon"
                                    width="32px"
                                    height="32px"
                                    alt=""
                                    class="max-2xl:w-7 max-2xl:h-7 max-md:w-5 max-md:h-5"
                                />
                                <div
                                    class="text-[22px] leading-[61px] max-2xl:text-[18px] max-2xl:leading-10 max-md:text-[16px] max-md:leading-10"
                                >
                                    {{ country.name }}
                                </div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="hidden max-lg:flex">
                    <div
                        class="inline-block cursor-pointer"
                        (click)="openTabMenu()"
                        [ngClass]="{ change: this.openMenuMobile }"
                    >
                        <div class="bar1"></div>
                        <div class="bar2"></div>
                        <div class="bar3"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}

<div #menuMobile class="menu-mobile">
    <div (click)="openTabMenu()" class="close-menu-mobile">
        <span class="material-symbols-outlined"> cancel </span>
        <p class="text-white">{{ "common.close_tab" | translate }}</p>
    </div>
    <nav id="nav-mobile">
        <ul id="navigation-mobile" class="flex flex-col">
            @for (item of menus()?.values; track $index) {
            @if(item.description.indexOf( '/tuyen-dung' ) >= 0 ||
            item.description.indexOf( '/recruit' ) >= 0 ||
            item.description.indexOf( '/su-kien' ) >= 0 ||
            item.description.indexOf( '/event' ) >= 0){
            <li class="text-base capitalize max-sm:text-sm">
                <a
                    class="px-4 py-4 block max-2xl:px-2"
                    [routerLink]="item.description"
                    [routerLinkActiveOptions]="{
                        exact: false
                    }"
                    [routerLinkActive]="['is-active']"
                    (click)="closeTab()"
                    >{{ item.title }}
                </a>
            </li>
            } @else if (item.description.indexOf('/ecosystem') >= 0) {
            <li class="ecosystem text-base capitalize max-sm:text-sm">
                <!-- <div
                    class="item-ecosystem relative cursor-pointer px-4 py-4 block max-2xl:px-2"
                    [class.is-active]="isLinkActive(item.description)"
                    (click)="menu.toggle($event)"
                >
                    {{ item.title }}
                </div> -->
                <div
                    class="item-ecosystem relative cursor-pointer px-4 py-4 block max-2xl:px-2"
                    (click)="op.toggle($event)"
                    [class.is-active]="isLinkActive(item.description)"
                >
                    {{ item.title }}
                </div>
                <!-- <p-menu
                    #menu
                    [model]="ecosystems"
                    [popup]="true"
                    [style]="{ left: '10px' }"
                >
                    <ng-template pTemplate="item" let-item>
                        <ng-container>
                            <a
                                class="block p-2 text-sm capitalize"
                                [routerLink]="'/ecosystem/' + item.link"
                                [routerLinkActiveOptions]="{
                                    exact: true
                                }"
                                [routerLinkActive]="['is-active-item']"
                                (click)="closeTab()"
                            >
                                {{ item.title }}
                            </a>
                        </ng-container>
                    </ng-template>
                </p-menu> -->
            </li>
            } @else {
            <li class="text-base capitalize max-sm:text-sm">
                <a
                    class="px-4 py-4 block max-2xl:px-2"
                    [routerLink]="item.description"
                    [routerLinkActiveOptions]="{
                        exact: true
                    }"
                    [routerLinkActive]="['is-active']"
                    (click)="closeTab()"
                    >{{ item.title }}
                </a>
            </li>
            } }
        </ul>
    </nav>
</div>

<p-popover #op [baseZIndex]="99999" [style]="{ width: '150px', left: '10px' }">
    <nav>
        <ul>
            @for (item of ecosystems; track $index) {
            <li
                class="bg-white text-[14px] text-black font-semibold max-lg:text-sm max-lg:capitalize max-lg:font-normal"
            >
                <a
                    class="block p-2"
                    routerLink="/ecosystem/{{ item.link }}/{{
                        this.localeDefaultService()?.code === 'en' ? '/en' : ''
                    }}"
                    [routerLinkActiveOptions]="{
                        exact: true
                    }"
                    [routerLinkActive]="['is-active-item']"
                    (click)="op.hide(); closeTab()"
                >
                    {{ item.title }}
                </a>
            </li>
            }
        </ul>
    </nav>
</p-popover>
